import { render, staticRenderFns } from "./WebForms.vue?vue&type=template&id=5257373e&"
import script from "./WebForms.vue?vue&type=script&lang=js&"
export * from "./WebForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports